// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"a2ceaf20","453":"603d37e8"}[chunkId] + ".chunk.js";
};